import { useEffect, useRef } from 'react';
import { Modal } from '@leagueplatform/genesis-core';
import { QUERY_PARAM_KEYS, QUERY_PARAM_MODAL_VALUE } from 'common/constants';
import { AccountDeletionConfirmationModal } from 'components/modals/account-deletion-confirmation-modal.component';
import { DeleteAccountModal } from 'components/modals/delete-account-modal.component';
import { useUrlParam } from 'hooks/use-url-param.hook';

const PRIVATE_MODAL_MAP: Record<string, React.ElementType | undefined> = {
  [QUERY_PARAM_MODAL_VALUE.DELETE_ACCOUNT]: DeleteAccountModal,
};

const PUBLIC_MODAL_MAP: Record<string, React.ElementType | undefined> = {
  [QUERY_PARAM_MODAL_VALUE.DELETE_ACCOUNT_DISCLAIMER]:
    AccountDeletionConfirmationModal,
};

export const QueryParamModal = ({ isPublic }: { isPublic?: boolean }) => {
  const { removeParam, urlParam } = useUrlParam(QUERY_PARAM_KEYS.MODAL);
  const triggerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (urlParam) {
      triggerRef.current ??=
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
    } else {
      triggerRef.current = null;
    }
  }, [urlParam]);

  const modalMap = isPublic ? PUBLIC_MODAL_MAP : PRIVATE_MODAL_MAP;

  if (!urlParam) return null;

  const Component = Object.hasOwn(modalMap, urlParam)
    ? modalMap[urlParam]
    : undefined;

  if (!Component) return null;

  const handleClose = () => {
    removeParam();
    triggerRef.current?.focus();
  };

  return (
    <Modal.Root open onOpenChange={handleClose}>
      <Component onClose={handleClose} />
    </Modal.Root>
  );
};
